var _rect, _path, _text, _text2, _text3, _rect2, _path2, _line, _text4, _text5, _line2, _text6, _text7, _line3, _text8, _text9, _line4, _text10, _text11, _line5, _text12, _text13, _text14, _text15, _text16, _text17, _line6, _text18, _text19, _text20, _line7, _text21, _text22, _text23, _line8, _text24, _text25, _text26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPledgesInstructions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1536,
    height: 982,
    viewBox: "0 0 1536 982",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1536,
    height: 982,
    fill: "#ffffff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 1230 0 H 1536 V 26 H 1270 Q 1240 20 1230 0 Z",
    fill: "#0b2f66"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 120,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 58,
    fontWeight: 700,
    fill: "#0b2f66"
  }, "PULL YOUR OPEN PLEDGES DATA (EXPORT)")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 177,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 33,
    fill: "#1a1a1a"
  }, "Use your CRM to export all open pledges data, Use the export function in RE.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 225,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 32,
    fontWeight: 700,
    fill: "#0b2f66"
  }, "Save the file as CSV (.csv).")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 268,
    width: 1398,
    height: 670,
    rx: 24,
    ry: 24,
    fill: "none",
    stroke: "#244f84",
    strokeWidth: 2.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 94 268 H 1444 Q 1468 268 1468 292 V 322 H 70 V 292 Q 70 268 94 268 Z",
    fill: "#0b2f66"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 470,
    y1: 268,
    x2: 470,
    y2: 938,
    stroke: "#244f84",
    strokeWidth: 1.6
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 104,
    y: 304,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "white"
  }, "FIELD NAME (ALL REQUIRED)")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 304,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "white"
  }, "DESCRIPTION")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 322,
    x2: 1468,
    y2: 322,
    stroke: "#244f84",
    strokeWidth: 1.4
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 104,
    y: 358,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 24,
    fill: "#1a1a1a"
  }, "Constituent ID")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 358.5,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fill: "#1a1a1a"
  }, "Unique identifier for each donor; repeats for donors with multiple gifts.")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 380,
    x2: 1468,
    y2: 380,
    stroke: "#244f84",
    strokeWidth: 1.4
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 104,
    y: 416,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 24,
    fill: "#1a1a1a"
  }, "Gift ID")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 416.5,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fill: "#1a1a1a"
  }, "If Gift ID is not on all gifts, use Gift Import ID.")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 438,
    x2: 1468,
    y2: 438,
    stroke: "#244f84",
    strokeWidth: 1.4
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 104,
    y: 476,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 24,
    fill: "#1a1a1a"
  }, "Gift Date")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 476.5,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fill: "#1a1a1a"
  }, "The date the gift/commitment was made.")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 500,
    x2: 1468,
    y2: 500,
    stroke: "#244f84",
    strokeWidth: 1.4
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 104,
    y: 591,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 24,
    fill: "#1a1a1a"
  }, "Installment Import ID")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 541.5,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fill: "#1a1a1a"
  }, "The Import ID of the pledge installment. Add additional columns as new")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 566.5,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fill: "#1a1a1a"
  }, "installments on the right side of the document and note them with an")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 591.5,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fill: "#1a1a1a"
  }, "underscore followed by the installment number. Each installment should")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 616.5,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fill: "#1a1a1a"
  }, "include an Import ID, Installment Date, Installment Amount and")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 641.5,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fill: "#1a1a1a"
  }, "Installment Balance.")), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 668,
    x2: 1468,
    y2: 668,
    stroke: "#244f84",
    strokeWidth: 1.4
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 104,
    y: 720,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 24,
    fill: "#1a1a1a"
  }, "Installment Amount")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 708,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fill: "#1a1a1a"
  }, "The amount of the pledge installment.")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 733,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fill: "#1a1a1a",
    fontStyle: "italic"
  }, "* See Installment Import ID for additional note.")), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 758,
    x2: 1468,
    y2: 758,
    stroke: "#244f84",
    strokeWidth: 1.4
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 104,
    y: 810,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 24,
    fill: "#1a1a1a"
  }, "Installment Balance")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 798,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fill: "#1a1a1a"
  }, "The balance of the pledge installment.")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 823,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fill: "#1a1a1a",
    fontStyle: "italic"
  }, "* See Installment Import ID for additional note.")), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 848,
    x2: 1468,
    y2: 848,
    stroke: "#244f84",
    strokeWidth: 1.4
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 104,
    y: 900,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 24,
    fill: "#1a1a1a"
  }, "Installment Date")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 888,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fill: "#1a1a1a"
  }, "The date of the pledge installment.")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 913,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 22,
    fill: "#1a1a1a",
    fontStyle: "italic"
  }, "* See Installment Import ID for additional note.")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPledgesInstructions);
export default __webpack_public_path__ + "static/media/pledges_instructions.aab7f1503c60edc27e1dbac44abe4802.svg";
export { ForwardRef as ReactComponent };